import { Routes } from '@angular/router';

export const discountRoutes: Routes = [
  // Discount Profile
  {
    path: 'manual-discount-profile',
    data: { moduleCode: 'disc_profile' },
    children: [
      { path: '', loadComponent: () => import('./discount-profile/discount-profile').then((m) => m.DiscountProfile) },
      {
        path: 'add',
        loadComponent: () =>
          import('./discount-profile/discount-profile-details/discount-profile-details').then((m) => m.DiscountProfileDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./discount-profile/discount-profile-details/discount-profile-details').then((m) => m.DiscountProfileDetails)
      },
      {
        path: 'import',
        loadComponent: () =>
          import('./discount-profile/discount-profile-import/discount-profile-import').then((m) => m.DiscountProfileImport)
      }
    ]
  },

  // New Manual Discount Creation
  {
    path: 'new-manual-discount-creation',
    data: { moduleCode: 'disc_new_disc_creation' },
    children: [
      { path: '', loadComponent: () => import('./discount-creation/discount-creation').then((m) => m.DiscountCreation) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./discount-profile/discount-profile-details/discount-profile-details').then((m) => m.DiscountProfileDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },

  // Update Manual Discount Req
  {
    path: 'manual-discount-details-update',
    data: { moduleCode: 'disc_disc_details_upd' },
    children: [
      { path: '', loadComponent: () => import('./discount-update/discount-update').then((m) => m.UpdateManualDiscountReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./discount-profile/discount-profile-details/discount-profile-details').then((m) => m.DiscountProfileDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },
  // Promotional Discount Profile
  {
    path: 'promotional-discount-profile',
    data: { moduleCode: 'disc_sales_disc_profile' },
    children: [
      {
        path: '',
        loadComponent: () => import('./promotion-discount-profile/promotion-discount-profile').then((m) => m.PromotionDiscountProfile)
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./promotion-discount-profile/promo-discount-details/promo-discount-details').then((m) => m.PromoDiscountDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./promotion-discount-profile/promo-discount-details/promo-discount-details').then((m) => m.PromoDiscountDetails)
      },
      {
        path: 'import',
        loadComponent: () =>
          import('./promotion-discount-profile/promo-discount-import/promo-discount-import').then((m) => m.PromoDiscountImport)
      }
    ]
  },
  // New Promotional Discount Creation
  {
    path: 'new-promotional-discount-creation',
    data: { moduleCode: 'disc_new_sales_disc_creation' },
    children: [
      {
        path: '',
        loadComponent: () => import('./promotion-discount-profile/new-promo-disc-req/new-promo-disc-req').then((m) => m.NewPromoDiscReq)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./promotion-discount-profile/promo-discount-details/promo-discount-details').then((m) => m.PromoDiscountDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },

  // Update Promotional Discount Creation
  {
    path: 'promotional-discount-details-update',
    data: { moduleCode: 'disc_sales_disc_details_upd' },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./promotion-discount-profile/update-promo-disc-req/update-promo-disc-req').then((m) => m.UpdatePromoDiscReq)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./promotion-discount-profile/promo-discount-details/promo-discount-details').then((m) => m.PromoDiscountDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  }
];
